import { render, staticRenderFns } from "./ShopMoneyFlow.vue?vue&type=template&id=be3b8974&scoped=true"
import script from "./ShopMoneyFlow.vue?vue&type=script&lang=js"
export * from "./ShopMoneyFlow.vue?vue&type=script&lang=js"
import style0 from "./ShopMoneyFlow.vue?vue&type=style&index=0&id=be3b8974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3b8974",
  null
  
)

export default component.exports